module.exports = __webpack_public_path__ + "static/media/F Pop up 8.e64d9f75.png";